import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Also attach Bearer token if present in localStorage (fallback for cross-site cookie issues)
api.interceptors.request.use((config) => {
    const t = localStorage.getItem("atia_session_token");
    if (t) {
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

export default api;
